import { makeAutoObservable, runInAction } from "mobx";

import { IRootStore } from "@/app/model/rootStore";

import { voiceChatService } from "../api/voiceChatService";
import {
  IProcessVoiceConversationParams,
  IStartVoiceConversationParams,
  IStopVoiceConversationParams,
  IVoiceConversationStatusParams,
  VoiceConversationStatus,
} from "./types";

export class VoiceChatStore {
  rootStore: IRootStore;
  conversationId: null | string = null;

  constructor(rootStore: IRootStore) {
    makeAutoObservable(this);

    this.rootStore = rootStore;
  }

  async startVoiceConversation(params: IStartVoiceConversationParams) {
    const response = await voiceChatService.startVoiceConversation(params);

    runInAction(() => {
      this.conversationId = response.conversation_id;
    });

    return response;
  }

  async processVoiceConversation(params: IProcessVoiceConversationParams) {
    const response = await voiceChatService.processVoiceConversation(params);
    return response;
  }

  async stopVoiceConversation(params: IStopVoiceConversationParams) {
    const response = await voiceChatService.stopVoiceConversation(params);
    return response;
  }

  async getVoiceConversationStatus(params: IVoiceConversationStatusParams) {
    const response = await voiceChatService.getVoiceConversationStatus(params);

    runInAction(() => {
      if (response.status === VoiceConversationStatus.ACTIVE) {
        this.conversationId = response.conversation_id;
        this.rootStore.dialogsStore.setActiveDialogId(response.dialog_id);
      }
    });

    return response;
  }
}
